import { setCachedPremiumPicks } from "../../../../helpers/cache-premium-picks";

// Action Types
const name = "PREMIUM_PICKS_CATALOG";
const LOAD_PREMIUM_PICKS_LIST = `${name}/LOAD_PREMIUM_PICKS_LIST`;
const IS_LOADING_PREMIUM_PICKS = `${name}/IS_LOADING_PREMIUM_PICKS`;

// Reducer
const initialState = {
  currentPicks: {},
  upcomingPicks: {},
  isLoading: true,
  loadError: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_PREMIUM_PICKS_LIST:
      return {
        ...state,
        currentPicks: action.currentPicks,
        upcomingPicks: action.upcomingPicks,
        isLoading: false,
        loadError: null
      };
    case IS_LOADING_PREMIUM_PICKS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
}

// Actions
export const fetchPremiumPicks = () => {
  return async function(dispatch) {
    dispatch({ type: IS_LOADING_PREMIUM_PICKS });

    Promise.resolve($.get(`/v4/2023-rotating-catalog`))
      .then(async response => {
        setCachedPremiumPicks(response);
        dispatch({
          type: LOAD_PREMIUM_PICKS_LIST,
          currentPicks: response.current,
          upcomingPicks: response.next
        });
      })
      .catch(err => {
        dispatch({ type: LOAD_PREMIUM_PICKS_LIST, loadError: err });
      });
  };
};
